/**
 * Эффект печати и реверс (удаление с конца) как в редакторе кода (02_GPT-MODULAR).
 */

import { useState, useEffect, useRef } from "react";
import "./Typewriter.css";

function Typewriter({
    text = "",
    speed = 80,
    delay = 0,
    reverse = false,
    fullText = "",
    targetText = "",
    onComplete,
}) {
    const isReverse = reverse && fullText !== "" && targetText !== undefined;

    const [display, setDisplay] = useState(isReverse ? fullText : "");
    const [started, setStarted] = useState(false);
    const completedRef = useRef(false);

    useEffect(() => {
        completedRef.current = false;
    }, [isReverse, fullText, targetText, text]);

    useEffect(() => {
        if (!onComplete || !started) return;
        const done = isReverse
            ? display.length <= targetText.length
            : display.length >= text.length;
        if (done && !completedRef.current) {
            completedRef.current = true;
            onComplete();
        }
    }, [started, isReverse, display, text, fullText, targetText, onComplete]);

    useEffect(() => {
        if (isReverse) {
            setDisplay(fullText);
            setStarted(false);
            const t = setTimeout(() => setStarted(true), delay);
            return () => clearTimeout(t);
        }
        setDisplay("");
        setStarted(false);
        const t = setTimeout(() => setStarted(true), delay);
        return () => clearTimeout(t);
    }, [isReverse, fullText, targetText, text, delay]);

    useEffect(() => {
        if (!started) return;

        if (isReverse) {
            if (display.length <= targetText.length) return;
            const t = setTimeout(() => {
                setDisplay((d) => d.slice(0, -1));
            }, speed);
            return () => clearTimeout(t);
        }

        if (display.length >= text.length) return;
        const t = setTimeout(() => {
            setDisplay(text.slice(0, display.length + 1));
        }, speed);
        return () => clearTimeout(t);
    }, [started, isReverse, display, text, fullText, targetText, speed]);

    const showCursor =
        isReverse ? display.length > targetText.length : display.length < text.length;

    return (
        <span className="typewriter">
            {display}
            {showCursor && <span className="typewriter__cursor" aria-hidden="true" />}
        </span>
    );
}

export default Typewriter;
// components/Typewriter/Typewriter.js
